import $ from 'jquery';

/*
 * ComedianSlider
 * TODO: move into hero block
 */

class ComedianSlider {
  constructor() {
    this.currentIndex;
    this.$el = $('.ComedianSlider');
    this.$slides = this.$el.find('.ComedianSlider-slide');
    if(!this.$el) return;
    this.run();
  }

  run() {
    // init currentIndex
    this.currentIndex = this.$slides.filter('[data-active="true"]').index();
    console.log('initialIndex', this.currentIndex);

    setInterval(() => {
      this.step();
    }, 5000);
  }

  step() {
    const nextIndex = this.currentIndex+1 >= this.$slides.length ? 0 : this.currentIndex+1;
    console.log('step!', this.currentIndex, '=>', nextIndex);

    this.$slides.eq(this.currentIndex).attr('data-active', 'false');
    this.$slides.eq(nextIndex).attr('data-active', 'true');

    this.currentIndex = nextIndex;    

  }
}

$(function() {
  new ComedianSlider();
});
